import { defineStore } from "pinia";
import axios from "axios";
import { useLoadingStore } from "@/stores/loadingStore";

export const useSettingsStore = defineStore("settings", {
  state: () => ({
    settings: {},
    isLoading: false,
    error: null,
  }),

  actions: {
    async fetchSettings() {
      const loadingStore = useLoadingStore();
      loadingStore.startLoading();
      this.isLoading = true;
      this.error = null;
      try {
        const response = await axios.get("/api/SiteSettings/GetGlobalSettings");
        this.settings = response.data.Payload;
      } catch (error) {
        this.error = "Ayarlar alınırken bir hata oluştu";
      } finally {
        this.isLoading = false;
        loadingStore.finishLoading();
      }
    },
  },

  getters: {
    siteTitle: (state) => state.settings.site_title || "",

    siteDescription: (state) => state.settings.site_description || "",
    footerText: (state) => state.settings.footer_text || "",
    siteLogo: (state) => state.settings.site_logo || "",
  },
});
